export default [
  {
    id: 'CLP',
    nombre: 'CLP'
  },
  {
    id: 'CLF',
    nombre: 'UF'
  },
  {
    id: 'UTM',
    nombre: 'UTM'
  },
  {
    id: 'EUR',
    nombre: 'EURO'
  },
  {
    id: 'USD',
    nombre: 'DOLAR'
  }
];
